import React, { useState, useEffect } from 'react'

import { GridRenderCellParams, DataGridPro, GridRowsProp, GridColDef, GridToolbar, useGridApiRef, GridFilterModel, DataGridPremium, GridRowModel } from '@mui/x-data-grid-premium';

import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import { createStyles, makeStyles } from '@mui/styles';
import styles from '../../componentsStyle/upload.module.css';
import { createTheme, darken, lighten } from '@mui/material/styles';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import QrCheck from './qrcheck';
import Todos from '../new/todos';
import totalLocationData from '../../../data/locationdata';
import SkeletonComp from './etc/skeletoncomp';




const defaultTheme = createTheme();
const useStyles2 = makeStyles(
  (theme) => {
    const getBackgroundColor = (color: any) =>
      theme.palette.mode === 'dark' ? darken(color, 0.6) : lighten(color, 0.6);

    const getHoverBackgroundColor = (color: any) =>
      theme.palette.mode === 'dark' ? darken(color, 0.5) : lighten(color, 0.5);

    return {
      root: {
        '& .super-app-theme--처리완료': {
          backgroundColor: getBackgroundColor(theme.palette.info.main),
          '&:hover': {
            backgroundColor: getHoverBackgroundColor(theme.palette.info.main),
          },
        },
        '& .super-app-theme--Filled': {
          backgroundColor: getBackgroundColor(theme.palette.success.main),
          '&:hover': {
            backgroundColor: getHoverBackgroundColor(theme.palette.success.main),
          },
        },
        '& .super-app-theme--확인': {
          backgroundColor: getBackgroundColor(theme.palette.warning.main),
          '&:hover': {
            backgroundColor: getHoverBackgroundColor(theme.palette.warning.main),
          },
        },
        '& .super-app-theme--미확인': {
          backgroundColor: getBackgroundColor(theme.palette.error.main),
          '&:hover': {
            backgroundColor: getHoverBackgroundColor(theme.palette.error.main),
          },
        },
        '& .timeout': {
          color: theme.palette.error.main,
        },
      },
    };
  },
  { defaultTheme },
);




interface GridCellExpandProps {
  value: string;
  width: number;
}


const useStyles = makeStyles(() =>
  createStyles({
    root: {
      alignItems: 'center',
      lineHeight: '24px',
      width: '100%',
      height: '100%',
      position: 'relative',
      display: 'flex',
      '& .cellValue': {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
    },
  }),
);


function isOverflown(element: Element): boolean {
  return (
    element.scrollHeight > element.clientHeight ||
    element.scrollWidth > element.clientWidth
  );
}


const GridCellExpand = React.memo(function GridCellExpand(
  props: GridCellExpandProps,
) {
  const { width, value } = props;
  const wrapper = React.useRef<HTMLDivElement | null>(null);
  const cellDiv = React.useRef(null);
  const cellValue = React.useRef(null);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const classes = useStyles();
  const [showFullCell, setShowFullCell] = React.useState(false);
  const [showPopper, setShowPopper] = React.useState(false);

  const handleMouseEnter = () => {
    const isCurrentlyOverflown = isOverflown(cellValue.current!);
    setShowPopper(isCurrentlyOverflown);
    setAnchorEl(cellDiv.current);
    setShowFullCell(true);
  };

  const handleMouseLeave = () => {
    setShowFullCell(false);
  };

  React.useEffect(() => {
    if (!showFullCell) {
      return undefined;
    }

    function handleKeyDown(nativeEvent: KeyboardEvent) {
      // IE11, Edge (prior to using Bink?) use 'Esc'
      if (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc') {
        setShowFullCell(false);
      }
    }

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [setShowFullCell, showFullCell]);

  return (
    <div
      ref={wrapper}
      className={classes.root}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div
        ref={cellDiv}
        style={{
          height: 1,
          width,
          display: 'block',
          position: 'absolute',
          top: 0,
        }}
      />
      <div ref={cellValue} className="cellValue">
        {value}
      </div>
      {showPopper && (
        <Popper
          open={showFullCell && anchorEl !== null}
          anchorEl={anchorEl}
          style={{ width, marginLeft: -17 }}
        >
          <Paper
            elevation={1}
            style={{ minHeight: wrapper.current!.offsetHeight - 3 }}
          >
            <Typography variant="body2" style={{ padding: 8 }}>
              {value}
            </Typography>
          </Paper>
        </Popper>
      )}
    </div>
  );
});

function renderCellExpand(params: GridRenderCellParams<any>) {
  return (
    <GridCellExpand value={params.value || ''} width={params.colDef.computedWidth} />
  );
}









const columns: GridColDef[] = [
  { field: 'time', headerName: '시간', width: 120, filterable: false },
  { field: 'description', headerName: '내용', width: 730, renderCell: renderCellExpand, filterable: false },
  { field: 'answer', headerName: '완료 답변', width: 150, editable: true, renderCell: renderCellExpand, filterable: false },
  { field: 'answerTime', headerName: '완료시간', width: 150, renderCell: renderCellExpand, filterable: false },
  { field: 'answerName', headerName: '답변인', width: 150, renderCell: renderCellExpand, filterable: false },
  { field: 'location', headerName: '장소', width: 100 },
  { field: 'ip', headerName: 'IP', width: 150, renderCell: renderCellExpand, filterable: false },
  { field: 'block', headerName: '', width: 150, renderCell: renderCellExpand, filterable: false },

];

const WorkLoadToday: React.FC<any> = (props) => {
  const classes = useStyles2();
  const [rows, setRows] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [editRowsModel, setEditRowsModel] = React.useState({});
  const [alignment, setAlignment] = React.useState('total');

  const [update, setUpdate] = useState(0);
  const [currentTime, setCurrentTime] = useState(new Date().getHours() * 60 + new Date().getMinutes());

  const [filterModel, setFilterModel] = React.useState<GridFilterModel>({
    items: [
    ],
  });

  useEffect(() => {
    setTimeout(() => {
      setUpdate(Math.random());
    }, 40000);
  }, []);



  useEffect(() => {

    if(update === 0){
    setLoading(true);
    }

    setTimeout(() => {
      setCurrentTime(new Date().getHours() * 60 + new Date().getMinutes());
    }, 20000)


    const start = async () => {
      var token = "";
      if (window.electron) {
        token = await window.electron.sendMessageApi.getToken();
      }

      fetch("https://peetsunbae.com/dashboard/report/work", {
        method: "GET",
        headers: { "Authorization": token },
        credentials: "include",
      }).then((response: any) => {
        response.json()
          .then((result: any) => {

            
            const data = result.data;
            const answers = result.answer;

            data.sort(function (a: any, b: any) {
              if (a.startTime > b.startTime) {
                return 1;
              }
              if (a.startTime === b.startTime) {
                if (a.endTime >= b.endTime) {
                  return 1;
                } else {
                  return -1;
                }
              }
              if (a.startTime < b.startTime) {
                return -1;
              }
            });
            

            const newRows: any = [];

            data.forEach((each: any, number: number) => {
              const oneRow: any = {};
              oneRow.id = each.id;
              oneRow.time = `${Math.floor(each.startTime / 60) < 10 ? "0" + Math.floor(each.startTime / 60) : Math.floor(each.startTime / 60)}:${each.startTime % 60 < 10 ? "0" + each.startTime % 60 : each.startTime % 60}~${Math.floor(each.endTime / 60) < 10 ? "0" + Math.floor(each.endTime / 60) : Math.floor(each.endTime / 60)}:${each.endTime % 60 < 10 ? "0" + each.endTime % 60 : each.endTime % 60}`
              oneRow.location = each.location;
              oneRow.description = each.description;
              oneRow.startTime = each.startTime;
              oneRow.endTime = each.endTime;
              oneRow.block = "--------------------------------------";
              answers.forEach((answer: any) => {
                if (answer.workId === each.id) {
                  oneRow.answer = answer.answer;
                  const answerDate = new Date(answer.answerTime);
                  oneRow.answerTime = `${answerDate.getHours() < 10 ? "0" + answerDate.getHours() : answerDate.getHours()} : ${answerDate.getMinutes() < 10 ? "0" + answerDate.getMinutes() : answerDate.getMinutes()}`;
                  oneRow.ip = answer.ip;
                  oneRow.answerName = answer.answerUserName;
                }
              })
              newRows.push(oneRow);
            });

            setRows([...newRows]);

            setLoading(false);
          })
      })
    }

    start();
  }, [update]);

  const handleCommit = async (newRow: GridRowModel, old: any) => {

    var field = "";
    

    for (const [key, value] of Object.entries(newRow)) {
      if (value !== old[key]) {
        field = key;
        
      }
    }

    const id = newRow.id;
    var value = newRow[field];
    

    if (!value) {
      value = "";
    }

    var token = "";
    if (window.electron) {
      token = await window.electron.sendMessageApi.getToken();
    }

    fetch(`https://peetsunbae.com/dashboard/report/work`, {
      method: "PATCH",
      headers: { "Authorization": token, "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({
        id, field, value
      })
    }).then((response: any) => {
      response.json()
        .then((result: any) => {
          
          setUpdate(Math.random());
        })
    })

    return newRow;
  }

  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: string,
  ) => {

    if (newAlignment === null) {
      return;
    }

    
    setAlignment(newAlignment);

    // switch (newAlignment) {
    //   case "all":
    //     setFilterModel({
    //       items: []
    //     });
    //     break;
    //   case "desk":
    //     setFilterModel({
    //       items: [
    //         { id: 1, field: 'location', operator: 'contains', value: '강남 데스크' },
    //       ],
    //     });
    //     break;
    //   case "coach":
    //     setFilterModel({
    //       items: [
    //         { id: 1, field: 'location', operator: 'contains', value: '강남 사감' },
    //       ],
    //     });
    //     break;
    //   case "desk2":
    //     setFilterModel({
    //       items: [
    //         { id: 1, field: 'location', operator: 'contains', value: '대치 데스크' },
    //       ],
    //     });
    //     break;
    //   case "coach2":
    //     setFilterModel({
    //       items: [
    //         { id: 1, field: 'location', operator: 'contains', value: '대치 사감' },
    //       ],
    //     });
    //     break;
    //   case "desk3":
    //     setFilterModel({
    //       items: [
    //         { id: 1, field: 'location', operator: 'contains', value: '대치 3층 데스크' },
    //       ],
    //     });
    //     break;
    //   case "coach3":
    //     setFilterModel({
    //       items: [
    //         { id: 1, field: 'location', operator: 'contains', value: '대치 3층 사감' },
    //       ],
    //     });
    //     break;
    //   case "desk4":
    //     setFilterModel({
    //       items: [
    //         { id: 1, field: 'location', operator: 'contains', value: '대치 6층 데스크' },
    //       ],
    //     });
    //     break;
    //   case "coach4":
    //     setFilterModel({
    //       items: [
    //         { id: 1, field: 'location', operator: 'contains', value: '대치 6층 사감' },
    //       ],
    //     });
    //     break;
    // }

    totalLocationData.forEach((location) => {
      if (!location.jobs) {
        return null;
      }

      location.jobs.forEach((job) => {
        if (job.english === newAlignment) {
          setFilterModel({
            items: [
              { id: 1, field: 'location', operator: 'contains', value: job.filterValue_contains },
            ],
          });
        }
      })
    })

  };


  const handleProcessRowUpdateError = React.useCallback((error: Error) => {
    
    alert(error.message);
  }, []);



  return (
    <div>

      {
        loading ?
          <div>
            <SkeletonComp />
          </div>
          :
          <>

            <Todos user={props.user} />

            <div style={{ height: "40px" }}>

            </div>

            <Todos user={props.user} type="exchange" />

            <div style={{ height: "60px" }}>

            </div>

            <div className={styles.mysearchDate}>
              <div className={styles.caution2}>
                - '꼭!' 업무 완료 후에 답변 적어주세요. (업무 완료 전에 미리 작성하지 말기) : ) <br>
                </br>
                - '완료 답변'은 구체적으로 적어주세요.
              </div>
              <div>
                <ToggleButtonGroup
                  color="primary"
                  value={alignment}
                  exclusive
                  onChange={handleChange}
                >
                  {/* <ToggleButton value="all">ALL</ToggleButton>
      <ToggleButton value="desk">강남 데스크</ToggleButton>
      <ToggleButton value="coach">강남 사감</ToggleButton>
      <ToggleButton value="desk2">대치 데스크</ToggleButton>
      <ToggleButton value="coach2">대치 사감</ToggleButton>
      <ToggleButton value="desk3">대치 3층 데스크</ToggleButton>
      <ToggleButton value="coach3">대치 3층 사감</ToggleButton>
      <ToggleButton value="desk4">대치 6층 데스크</ToggleButton>
      <ToggleButton value="coach4">대치 6층 사감</ToggleButton> */}
                  {
                    totalLocationData.map((location) => {

                      
                      
                      

                      if (props.user) {

                        if (!location.academy.includes(props.user.academy)) {
                          return null;
                        }

                      }

                      if (!location.jobs) {
                        return null;
                      }

                      return location.jobs.map((job, index) => {
                        return (
                          <ToggleButton key={index} value={job.english}>{job.korean}</ToggleButton>
                        )
                      })
                    })

                  }
                </ToggleButtonGroup>
              </div>
            </div>
            <div className={classes.root} style={{ height: 500, width: '100%', backgroundColor: "white" }}>

              <DataGridPremium loading={loading} rows={rows} columns={columns}
                density='compact'
                components={{ Toolbar: GridToolbar }}
                filterModel={filterModel}
                onFilterModelChange={(model) => setFilterModel(model)}
                getRowClassName={(params: any) => {
                  if (!params.row.answer) {
                    if (params.row.startTime <= currentTime && params.row.endTime >= currentTime) {
                      return (
                        "super-app-theme--확인"
                      )
                    } else if (params.row.startTime > currentTime) {
                      return (
                        "super-app-theme"
                      )
                    } else {
                      return (
                        "super-app-theme--미확인"
                      )
                    }
                  } else {
                    return (
                      "super-app-theme--처리완료"
                    )
                  }
                }
                }
                getCellClassName={(params: any) => {
                  if (params.field != "answerTime") {
                    return '';
                  } else if (!params.value) {
                    return '';
                  } else {
                    const hours = +(params.value.split(":")[0]);
                    const minutes = +(params.value.split(":")[1]);
                    const answerTimeValue = hours * 60 + minutes;
                    return (params.row.startTime > answerTimeValue || params.row.endTime < answerTimeValue) ? "timeout" : "";
                  }
                }}
                processRowUpdate={handleCommit}
                disableRowSelectionOnClick={true}
                onProcessRowUpdateError={handleProcessRowUpdateError}
              />

            </div>
            <div className={styles.mysearchDescription}>
              * 미완료 - 빨강색, 현재 할일 - 주황색, 완료 - 파랑색<br />
            </div>





            <QrCheck user={props.user} />


          </>
      }


    </div>
  )
}

export default WorkLoadToday;